'use client';
import React, { useState } from 'react';
import Link from 'next/link';
import { usePathname } from 'next/navigation';
import Icon from '@/components/ui/AppIcon';

const bottomTabs = [
  { label: 'Home', href: '/partner/mobile/home', icon: 'HomeIcon' },
  { label: 'Kavling', href: '/partner/mobile/kavling', icon: 'MapIcon' },
  { label: 'Lead', href: '/partner/mobile/lead', icon: 'UserGroupIcon' },
  { label: 'Reward', href: '/partner/mobile/reward', icon: 'GiftIcon' },
  { label: 'Profil', href: '/partner/mobile/profil', icon: 'UserCircleIcon' },
];

interface MobilePartnerLayoutProps {
  children: React.ReactNode;
  showFloatingButton?: boolean;
  onFloatingButtonClick?: () => void;
}

export default function MobilePartnerLayout({
  children,
  showFloatingButton = true,
  onFloatingButtonClick,
}: MobilePartnerLayoutProps) {
  const pathname = usePathname();

  const isTabActive = (href: string) =>
    pathname === href || pathname.startsWith(href + '/');

  return (
    <div className="min-h-screen bg-background flex flex-col max-w-md mx-auto relative">
      {/* Content area */}
      <main className="flex-1 overflow-y-auto pb-20">
        {children}
      </main>

      {/* Floating + Tambah Lead button */}
      {showFloatingButton && (
        <button
          onClick={onFloatingButtonClick}
          className="fixed bottom-24 right-4 z-40 w-14 h-14 rounded-full bg-primary text-white shadow-lg flex items-center justify-center hover:bg-primary/90 active:scale-95 transition-all"
          aria-label="Tambah Lead"
        >
          <Icon name="PlusIcon" size={26} />
        </button>
      )}

      {/* Bottom Navigation */}
      <nav className="fixed bottom-0 left-1/2 -translate-x-1/2 w-full max-w-md z-50 bg-card border-t border-border safe-area-bottom">
        <div className="flex items-center justify-around px-2 py-1.5">
          {bottomTabs.map((tab) => {
            const active = isTabActive(tab.href);
            return (
              <Link
                key={tab.href}
                href={tab.href}
                className={`flex flex-col items-center gap-0.5 px-3 py-1.5 rounded-xl transition-all flex-1 ${
                  active ? 'text-primary' : 'text-muted-foreground'
                }`}
              >
                <div className={`relative p-1 rounded-xl transition-all ${active ? 'bg-primary/10' : ''}`}>
                  <Icon name={tab.icon as any} size={22} />
                  {tab.label === 'Lead' && (
                    <span className="absolute -top-0.5 -right-0.5 w-2 h-2 bg-orange rounded-full" />
                  )}
                </div>
                <span className={`text-[10px] font-semibold leading-tight ${active ? 'text-primary' : 'text-muted-foreground'}`}>
                  {tab.label}
                </span>
              </Link>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
